import { bubbleDateClass } from "../messenger-elements/conv-message/bubble-style";

/**
 * Timestamp inside a chat bubble.
 *
 * `isBot` picks the contrast: the previous fixed `text-gray-300` was close to
 * invisible on the light bubble and illegible on the accent one.
 */
export default function ChatDate({date, isBot = true}) {
    if (!date) {
        return null;
    }

    return (
        <small className={`block text-[10px] tabular-nums ${bubbleDateClass(isBot)}`}>
            {date}
        </small>
    )
}
